// Migrated
<template>
  <b-modal
    v-bind="modalProps"
    :hide-footer="true"
    :hide-header="true"
    size="xl"
    body-class="p-1"
    content-class="rounded-none w-full"
    modal-class="md:pt-3"
    center
    @hide="onHide"
  >
    <div class="map-modal map-modal-fullscreen relative">
      <ModalCloseButton
        align="outside"
        @click="onHide"
      />
      <Mapbox
        class="absolute overflow-clip"
        :center="coordinates"
        :zoom="zoom"
        size-to-parent-bounds
      >
        <MapboxMarker :coordinates="coordinates" />
        <MapboxNavigationControl />
      </Mapbox>
    </div>
  </b-modal>
</template>

<script>
import Modal from '@packages/modals/Modal.vue'

export default defineNuxtComponent({
  props: {
    ...Modal.props,

    coordinates: {
      type: Array,
      required: true,
    },

    zoom: {
      type: Number,
      default: 16,
    },

    size: {
      type: String,
      default: 'xl',
    },
  },

  emits: ['onHide'],

  data () {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
      },
    }
  },

  computed: {
    modalProps () {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
      const { lat, lng, ...modalProps } = this.$props

      return modalProps
    },
  },

  methods: {
    onHide () {
      this.$emit('onHide')
    },
  },
})
</script>

<style lang="scss">
.map-modal.map-modal-fullscreen {
  min-height: 85vh;
}
</style>
